// extracted by mini-css-extract-plugin
module.exports = {"layout":"OrganisationStartApplication_layout__2Wyw8"};